import script from "./AppTgs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTgs.vue?vue&type=script&setup=true&lang=ts"

import "./AppTgs.vue?vue&type=style&index=0&id=61e3127b&lang=css"

const __exports__ = script;

export default __exports__